import { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './SocialButton.module.css';

interface SocialButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	icon?: ReactNode;
	fullWidth?: boolean;
}

export const SocialButton = ({
	children,
	icon,
	className,
	fullWidth,
	...props
}: SocialButtonProps) => {
	const buttonClass = `
    ${styles.social}
    ${fullWidth ? styles.fullWidth : ''}
    ${className || ''}
  `.trim();

	return (
		<button className={buttonClass} {...props}>
			{icon && <span className={styles.iconWrapper}>{icon}</span>}
			{children}
		</button>
	);
};
